import { FC } from 'react';

import Wrapper, { Description, New, Title, TitleSecondLine, Underline } from './Wrapper';
export type PricingSectionTitleBlockProps = {};

const PricingSectionTitleBlock: FC<PricingSectionTitleBlockProps> = () => (
  <Wrapper>
    <Title>
      <div>Video Editor, Video Hosting</div>
      <TitleSecondLine>
        <span>and</span>
        <Underline>
          <span>Live Streaming</span>
          <New />
        </Underline>
      </TitleSecondLine>
    </Title>
    <Description>Integrated video platform for one affordable price, perfect for all creative needs</Description>
  </Wrapper>
);

export default PricingSectionTitleBlock;
